export default [
    {
        value : 'Gerenciamento',
        text : 'Gerenciamento',
        icon : 'fa fa-cogs',
        color : '#00a65a'
    },
    {
        value :  'Suporte',
        text : 'Suporte',
        icon : 'fa fa-life-ring',
        color : '#f39c12'
    },
    {
        value :  'Prazo',
        text : 'Prazo',
        icon : 'fa fa-clock-o',
        color : '#f56954'
    },
    {
        value : 'Projeto',
        text : 'Projeto',
        icon : 'fa fa-tasks',
        color : '#00c0ef'
    }
]